import PropTypes from 'prop-types';
import organizationMembershipStatusShape from 'shapes/organizationMembershipStatusShape';
export const organization = PropTypes.shape({
    organizationUID: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    languageCode: PropTypes.string.isRequired,
    status: PropTypes.oneOf([
        'Active',
        'Pending'
    ]),
    logo: PropTypes.string,
    city: PropTypes.string,
    street: PropTypes.string,
    zipCode: PropTypes.string
});
export const organizationMembership = PropTypes.shape({
    identityUID: PropTypes.string.isRequired,
    organizationUID: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool,
    organization: organization.isRequired,
    status: organizationMembershipStatusShape.isRequired
});
export const organizationMembershipDetails = PropTypes.shape({
    identityUID: PropTypes.string.isRequired,
    organizationUID: PropTypes.string.isRequired,
    businessEmail: PropTypes.string.isRequired
});
